var render = function () {
  var _vm$walletData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('wallet-header', {
    attrs: {
      "walletData": _vm.walletData
    },
    scopedSlots: _vm._u([{
      key: "action-button",
      fn: function () {
        return [_c('span')];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "p-4 shadow-sm rounded withdraw-section"
  }, [_c('div', {
    staticClass: "form-section withdraw-form"
  }, [_c('h5', {
    staticClass: "fw-bold"
  }, [_vm._v("Withdrawal Request")]), _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v(" Enter your details below to withdraw money ")]), (_vm$walletData = _vm.walletData) !== null && _vm$walletData !== void 0 && _vm$walletData.walletData ? _c('div', {
    staticClass: "alert alert-info mb-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('small', {
    staticClass: "fw-bold"
  }, [_vm._v("Monthly Limit:")]), _c('span', {
    staticClass: "ms-2"
  }, [_vm._v(_vm._s(_vm.currentMonthTransactions) + " / " + _vm._s(_vm.maxTransactionsPerMonth))])]), _c('div', [_c('small', {
    staticClass: "fw-bold"
  }, [_vm._v("Minimum:")]), _c('span', {
    staticClass: "ms-2"
  }, [_vm._v(_vm._s(_vm.formatBalance(_vm.minimumTransaction)) + " " + _vm._s(_vm.walletCurrency))])])]), _vm.remainingTransactions <= 3 && _vm.remainingTransactions > 0 ? _c('div', {
    staticClass: "mt-2"
  }, [_c('small', {
    staticClass: "text-warning"
  }, [_vm._v(" ⚠️ " + _vm._s(_vm.remainingTransactions) + " transaction" + _vm._s(_vm.remainingTransactions === 1 ? "" : "s") + " remaining this month. ")])]) : _vm._e(), _vm.remainingTransactions === 0 ? _c('div', {
    staticClass: "mt-2"
  }, [_c('small', {
    staticClass: "text-danger"
  }, [_vm._v(" 🚫 Monthly transaction limit reached. Try again next month. ")])]) : _vm._e()]) : _vm._e(), _vm.successMessage ? _c('div', {
    staticClass: "alert alert-success mb-4"
  }, [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]) : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "alert alert-danger mb-4"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitWithdrawal.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "form-label amount-label"
  }, [_vm._v("Enter amount")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.amount,
      expression: "form.amount"
    }],
    staticClass: "form-control amount-input",
    class: {
      'is-invalid': _vm.errors.amount
    },
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": _vm.minimumTransaction,
      "placeholder": ("Minimum: " + (_vm.formatBalance(_vm.minimumTransaction)) + " " + (_vm.walletCurrency)),
      "disabled": _vm.remainingTransactions === 0
    },
    domProps: {
      "value": _vm.form.amount
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amount", $event.target.value);
      }, _vm.handleAmountInput],
      "keypress": _vm.restrictInput
    }
  }), _c('small', {
    staticClass: "text-muted balance-info"
  }, [_vm._v("Available balance: " + _vm._s(_vm.formatBalance(_vm.availableBalance)) + " " + _vm._s(_vm.walletCurrency))]), _vm.errors.amount ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.errors.amount) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "form-label fw-semibold"
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.email
    },
    attrs: {
      "type": "email",
      "placeholder": "johndoe@gmail.com",
      "disabled": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  }), _vm.errors.email ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.errors.email) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "form-label fw-semibold"
  }, [_vm._v("Binance wallet address / Id")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.walletAddress,
      expression: "form.walletAddress"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors.walletAddress
    },
    attrs: {
      "type": "text",
      "placeholder": "342957823",
      "disabled": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.form.walletAddress
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "walletAddress", $event.target.value);
      }
    }
  }), _vm.errors.walletAddress ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" " + _vm._s(_vm.errors.walletAddress) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "border-dashed my-4"
  }), _c('div', {
    staticClass: "d-flex justify-content-between fw-bold mb-3"
  }, [_c('span', [_vm._v("Amount to Withdraw")]), _c('span', {
    staticClass: "deducted-amount"
  }, [_vm._v(_vm._s(_vm.form.amount || "0.000000") + " Btc")])]), _c('div', {
    staticClass: "d-flex justify-content-between text-muted mb-3"
  }, [_c('span', [_vm._v("Processing Fee (" + _vm._s(_vm.processingFeeRate) + "%)")]), _c('span', {
    staticClass: "fee-amount"
  }, [_vm._v("- " + _vm._s(_vm.calculateFee()) + " Btc")])]), _c('div', {
    staticClass: "d-flex justify-content-between text-success fw-bold mb-3"
  }, [_c('span', [_vm._v("Total You Will Receive in Binance Wallet")]), _c('span', {
    staticClass: "total-amount"
  }, [_vm._v(_vm._s(_vm.calculateReceiveAmount()) + " Btc")])]), _c('div', {
    staticClass: "border-dashed my-4"
  }), _c('div', {
    staticClass: "d-flex gap-4"
  }, [_c('button', {
    staticClass: "btn withdraw-btn px-4",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitting || !_vm.canWithdraw
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmitting ? "Processing..." : "Withdraw") + " ")]), _c('button', {
    staticClass: "btn btn-outline-dark cancel-btn px-4 text-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelWithdrawal
    }
  }, [_vm._v(" Cancel ")])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }